<template>
  <transition name="slide-download" mode="out-in">
    <div v-if="downloadWaitNumber > 0" class="parent-download-loader">
      <v-icon class="spinner">
        fas fa-spinner
      </v-icon>
      <v-icon class="file">
        fas fa-file
      </v-icon>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'downloadWaitNumber',
    ]),
  },
};
</script>
<style scoped>
.parent-download-loader {
  position: fixed;
  bottom: 10px;
  height: 50px;
  width: 50px;
}
.spinner, .file {
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0.7;
  transform: translate(-50%,-50%);
}
.spinner {
  animation: fa-spin 1s infinite steps(8);
  font-size: 50px;
  top: 50%;
  left: 50%;
  right: 50%;
  bottom: 50%;
}
.file {
  opacity: 1;
  color: #484141;
  opacity: 1;
  font-size: 20px;
}
.slide-download-enter-active, .slide-download-leave-active {
  transition: all .3s ease;
}
.slide-download-leave-to, .slide-download-enter {
  transform: translateY(30px);
  opacity: 0;
}
</style>





// WEBPACK FOOTER //
// src/components/global/DownloadLoad.vue